import { WorldPoint } from './grid';
import { JsonDictionaryWrapper } from './utils';

export enum GunType {
    Basic,
    Turret,
}

// a single shot to a building
export type Shot = {
    source: WorldPoint,
    destination: WorldPoint,
    damage: number,
    t: number,
    transit_ticks: number,
}

export function shot_from_json(obj: JsonDictionaryWrapper): Shot {
    return {
        source: WorldPoint.create_json(obj.get_object("source")),
        destination: WorldPoint.create_json(obj.get_object("destination")),
        damage: obj.get_number("damage"),
        t: obj.get_number("t"),
        transit_ticks: obj.get_number("transit_ticks"),
    }
}

export interface FireControl {
    fire_shot(s: Shot): void
}

export class Gun {
    // how long after shooting can it fire again
    private _cooldown_ticks: number
    private _bullet_damage: number
    private _bullet_transit: number
    private _range: number
    private _t: number = 0
    private _gt: GunType

    constructor(gt: GunType) {
        this._gt = gt;
        switch (gt) {
            case GunType.Basic:
                this._cooldown_ticks = 60
                this._bullet_damage = 10
                this._bullet_transit = 10
                this._range = 5
                break;

            case GunType.Turret:
                this._cooldown_ticks = 60
                this._bullet_damage = 10
                this._bullet_transit = 10
                this._range = 8
                break;
        }
    }

    private toJSON(): any {
        return {
            gun_type: this._gt,
            t: this._t,
        }
    }

    public static create_json(obj: JsonDictionaryWrapper): Gun {
        let gt = obj.get_number("gun_type")
        let g = new Gun(gt)
        g._t  = obj.get_number("t")
        return g
    }

    public get range(): number {
        return this._range
    }

    public tick(): void {
        if (this._t > 0) {
            this._t -= 1
        }
    }

    public get can_fire(): boolean {
        return this._t == 0
    }

    public fire(source: WorldPoint, destination: WorldPoint): Shot {
        this._t = this._cooldown_ticks
        return {
            source: source,
            destination: destination,
            damage: this._bullet_damage,
            t: 0,
            transit_ticks: this._bullet_transit,
        }
    }
}
